import React from "react";
import Image from "@components/Image";
import Link from "@components/Link";
import Button from "@components/Button";
import styles from "./Card.module.scss";
import Bed from "@components/Icons/Room/Bed";
import Size from "@components/Icons/Room/Size";
import Location from "@components/Icons/Room/Location";
import AmountOfPeople from "@components/Icons/Room/AmountOfPeople";
import cx from "classnames";
import _ from "lodash";
import { useTranslationContext } from "@providers/TranslationProvider";
import { useRouteContext } from "@providers/RouteProvider";
import getter from "@services/RoomService/getter";

const View = ({ mode = "", onBooking, onDetail, ...data }: any) => {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  const isLight = mode === "light";
  const image = getter.image(_.get(data, "attributes.thumbnail"));
  return (
    <Link href={router.toUrl("room-detail", { slug: getter.slug(data) })}>
      <div className={cx(styles.item, styles[mode])}>
        <Image
          wrapperProps={{ className: cx(styles.image) }}
          src={_.get(image, "src")}
          alt={_.get(image, "alt")}
          scale={1.01}
          layout="fill"
          objectFit="cover"
        />
        <div className={cx("text-ellipsis-2", styles.title)}>
          {getter.name(data)}
        </div>
        <div
          className={cx("ama-content text-ellipsis-3 flex-1", styles.content)}
        >
          {getter.description(data)}
          {data.content}
        </div>
        <div className={styles.details}>
          <div className={styles.item}>
            <Size />
            <span>{getter.size(data)}</span>
          </div>
          <div className={cx(styles.item)}>
            <Bed />
            {getter.bedInfo(data)}
          </div>
          <div className={styles.item}>
            <AmountOfPeople />
            {getter.capacity(data)}
            {` `}
            {i18n.t("SearchControl.adults")}
          </div>
          {!!getter.location(data) && (
            <div className={styles.item}>
              <Location />
              {getter.location(data)}
            </div>
          )}
        </div>
        <div className={cx(styles.footer)}>
          <div className={cx(styles.validTime)}></div>
          <div className={cx(styles.btnGroup)}>
            <Button
              onClick={() => onDetail(data)}
              className={styles.viewThisRoom}
              type="text"
              label={i18n.t("Button.viewThisRoom")}
            />
            {!!isLight ? (
              <Button
                onClick={() => onBooking(data)}
                className={cx(styles.bookNow)}
                dark
                label={<>{i18n.t("Button.bookNow")}</>}
              />
            ) : (
              <Button
                onClick={() => onBooking(data)}
                className={cx(styles.bookNow)}
                label={<>{i18n.t("Button.bookNow")}</>}
              />
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};
export default View;
